import {ref, computed, ComputedRef} from "vue";


export interface DebugComposableObject {
    onclick:()=>void;
    displayString:ComputedRef<string>|string
}

export class DebugCookieEntry implements DebugComposableObject {
    private readonly cookieName: string;
    private readonly menueAnzeigeName: string;
    private readonly enabled = ref(false);
    public readonly displayString = computed(()=>this.menueAnzeigeName + (this.enabled.value ? "✔" : "❌"));
    public onclick = ()=>this.toggle();

    public constructor(cookieName: string, menueAnzeigeName = "") {
        this.cookieName = cookieName;
        this.menueAnzeigeName = menueAnzeigeName || cookieName;
        this.enabled.value = this.cookieExists();
    }

    cookieExists() {
        return document.cookie.split(";").some(i => i.trim().indexOf(this.cookieName) === 0);
    }

    public toggle() {
        if (this.enabled.value) {
            document.cookie = this.cookieName + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
        } else {
            document.cookie = this.cookieName + "=1; expires=Thu, 01 Jan 2050 00:00:01 GMT; path=/";
        }
        this.enabled.value = !this.enabled.value;
    }
}
